import React from "react";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";

import { useAuth } from "../../context/AuthContext";
import { isDailyLimit, isPlanRequired, planPathFor } from "../../constants/plans";

const DEFAULT_COPY = {
  athlete: "Esta función está incluida en el plan Pro de Athletain.",
  scout: "Esta función está incluida en los planes Pro, Elite y Enterprise para cazatalentos y entrenadores.",
};

/** Message for a gated action: the server's own copy when it sent one. */
export const upgradeMessage = (error, role) => {
  if ((isPlanRequired(error) || isDailyLimit(error)) && error?.message) return error.message;
  return DEFAULT_COPY[role] || DEFAULT_COPY.athlete;
};

/**
 * Friendly "this needs a plan" card. Purely UX: the backend is what refuses
 * the action. Pass the ApiError that blocked the action (plan_required or the
 * assistant's daily limit) or a `message`.
 */
const UpgradePrompt = ({ error = null, message, title, role: roleProp, className = "" }) => {
  const { userRole } = useAuth();
  const role = roleProp || userRole || "athlete";
  const heading =
    title || (isDailyLimit(error) ? "Llegaste al límite de hoy" : "Disponible con un plan de Athletain");
  return (
    <div
      role="status"
      data-testid="upgrade-prompt"
      className={`flex flex-col gap-3 rounded-xl border border-blue-200 bg-blue-50 p-4 text-sm text-blue-950 sm:flex-row sm:items-center ${className}`}
    >
      <div className="flex flex-1 items-start gap-3">
        <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-blue-900 text-white">
          <Sparkles size={16} aria-hidden="true" />
        </span>
        <div>
          <p className="font-semibold">{heading}</p>
          <p className="text-blue-900/80">{message || upgradeMessage(error, role)}</p>
        </div>
      </div>
      <Link
        to={planPathFor(role)}
        className="inline-flex shrink-0 items-center justify-center rounded-lg bg-blue-900 px-4 py-2 font-semibold text-white hover:bg-blue-800"
      >
        Ver planes
      </Link>
    </div>
  );
};

export default UpgradePrompt;
